import axios from 'axios';

axios.defaults.withCredentials = true;

export function get(url, params) {
  return axios.get(url, { params });
}

export function post(url, params) {
  const temp = new URLSearchParams();
  params
    && Object.keys(params).forEach((key) => {
      temp.append(key, params[key]);
    });
  return axios.post(url, temp);
}
